import React, { useState, useContext, useEffect } from "react";
import api from "../api";
import { UserContext } from '../UserContext';
import "../styles/search.css";

function Search() {
    const [kullaniciListesi, setKullaniciListesi] = useState([]);
    const [name, Setname] = useState("");
    const [tag, setTag] = useState("");
    const [tags, setTags] = useState([]);
    const { user } = useContext(UserContext);
    const [tagsuggeslist, setSagsuggeslist] = useState([]);
    const [countrys, setCountrys] = useState([]);
    const [maxFollowers, setMaxFollowers] = useState("");
    const [minFollowers, setMinFollowers] = useState("");
    const [sort, setSort] = useState("");
    const [socialMedia, setSocialMedia] = useState("");
    const [errors, setErrors] = useState([]);
    const [checked, setChecked] = useState(false);
    const [tag_p, setTag_p] = useState("");
    const [tags_p, setTags_p] = useState([]);
    const [countrys_p, setCountrys_p] = useState([]);
    const [selectedsearchtype, setSelectedsearchtype] = useState(0);
    const [isover, setIsOver] = useState(true);
    const [range, setRange] = useState(10);
    const [show, setShow] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState("Choose...");

    const handleShow = () => {
        setShow(true);
    };
    const handleClose = () => {
        setShow(false);
    }

    const handleCheckboxChange = (event) => {
        setChecked(event.target.checked);
    };

    const handleFilter = () => {
        if (minFollowers > maxFollowers && maxFollowers !== "") { setErrors(["Min followers can't be greater than max followers."]); return; }
        if (minFollowers < 0 || maxFollowers < 0) { setErrors(["Followers can't be negative."]); return; }
        if (socialMedia === "") { setErrors(["Please select a social media."]); return; }
        try {
            api.post("api/filter_user_by_social/", { countrys, tags, maxFollowers, minFollowers, sort, socialMedia, range }).then((res) => {
                if (res.status === 200) {
                    setKullaniciListesi(res.data.data);
                    setErrors([]);
                    setIsOver(res.data.isover);
                    if (res.data.data.length !== 0) {
                        setRange(range + 10);
                    }
                }
            })
        } catch (error) {
            setErrors(["An error occured."]);
        }
    }
    const handleFilter_p = () => {
        try {
            api.post("api/filter_user/", { countrys_p, tags_p, checked, range }).then((res) => {
                if (res.status === 200) {
                    setKullaniciListesi(res.data.data);
                    setErrors([]);
                    setIsOver(res.data.isover);
                    if (res.data.data.length !== 0) {
                        setRange(range + 10);
                    }
                }
            })
        } catch (error) {
            setErrors(["An error occured."]);
        }
    }



    const handleCountryChange = (event) => {
        const selected = event.target.value;

        if (countrys.length === 5) {
            setErrors(["You can only select 5 countries."]);
            return;
        }

        if (selected !== "Choose..." && !countrys.includes(selected)) {
            setCountrys([...countrys, selected]);
        }

        // Seçimi sıfırla
        setSelectedCountry("Choose...");
    };

    const handleCountryChange_p = (event) => {
        const selected = event.target.value;

        if (countrys_p.length === 5) {
            setErrors(["You can only select 5 countries."]);
            return;
        }

        if (selected !== "Choose..." && !countrys_p.includes(selected)) {
            setCountrys_p([...countrys_p, selected]);
        }

        // Seçimi sıfırla
        setSelectedCountry("Choose...");
    };



    const handleSetTag = (e) => {
        if (tags.length === 10) {
            // setErrors(["You can only select 5 countries."])
            return;
        }
        setTag(e);
        if (e === "") {
            setSagsuggeslist([]);
        } else {
            setTag(e);
        }
    };
    const handleSetTag_p = (e) => {
        if (tags_p.length === 10) {
            // setErrors(["You can only select 5 countries."])
            return;
        }
        setTag_p(e);
        if (e === "") {
            setSagsuggeslist([]);
        } else {
            setTag_p(e);
        }
    };

    useEffect(() => {
        if (tag === "") {
            setSagsuggeslist([]);
            return;
        }
        setSagsuggeslist(
            user.tags.filter((t) =>
                t.name.startsWith(tag)
            )
        );
        // eslint-disable-next-line
    }, [tag]);

    useEffect(() => {
        if (tag_p === "") {
            setSagsuggeslist([]);
            return;
        }
        setSagsuggeslist(
            user.tags.filter((t) =>
                t.name.startsWith(tag_p)
            )
        );
        // eslint-disable-next-line
    }, [tag_p]);

    const handleSubmit = async (e) => {
        if (name === "") {
            setKullaniciListesi([]);
            setIsOver(true);
            return;
        }
        try {
            const res = await api.post("api/search_user/", { name, range })
            if (res.status === 200) {
                setKullaniciListesi(res.data.data);
                setErrors([]);
                setIsOver(res.data.isover);
                if (res.data.data.length !== 0) {
                    setRange(range + 10);
                }
            }
        } catch (error) {
            setErrors(["An error occured."]);
        }
    };

    const handleloadmore = () => {
        if (selectedsearchtype === 0) {
            handleSubmit();
        }
        if (selectedsearchtype === 1) {
            handleFilter();
        }
        if (selectedsearchtype === 2) {
            handleFilter_p();
        }
    }

    function search_user() {
        return (<div href="#" className="list-group-item  d-flex gap-3 py-3 rounded-3" aria-current="true" >
            <div className="d-flex gap-2 w-100 justify-content-between">
                <div>
                    <div className="input-group mb-3">
                        <input
                            type="text"
                            className="form-control "
                            size="100"
                            onChange={(event) => Setname(event.target.value)}
                            placeholder="Username"
                            maxLength={254}
                            required
                        />
                        <button onClick={handleSubmit} className="btn btn-outline-secondary" type="button" id="button-addon2">Search</button>
                    </div>
                </div>
            </div>
        </div>)
    }

    function filter_by_social_media() {
        return (<div href="#" className="  list-group-item  d-flex gap-3 py-3 rounded-3" aria-current="true">
            <div className="d-flex gap-4 w-100 justify-content-center">
                <div>
                    <div className="container text-center pt-2 ">
                        {/* select social media */}
                        <div className="row">
                            <div style={{ minWidth: "150px" }} className="col mb-3">
                                <select defaultValue="Social Medya" className="form-select form-select" aria-label="Small select example" onChange={(e) => setSocialMedia(e.target.value)}>
                                    <option value="">Social Medya</option>
                                    <option value="Instagram">Instagram</option>
                                    <option value="Tiktok">Tiktok</option>
                                    <option value="Facebook">Facebook</option>
                                    <option value="X">X</option>
                                    <option value="Youtube">Youtube</option>
                                </select>
                            </div>
                            {/* <div className="col mb-3 ">

                            </div> */}
                        </div>
                        {/* max min followers */}
                        <div className="row">
                            <div style={{ minWidth: "150px" }} className="col ">
                                <div className="input-group mb-3">

                                    <input onChange={(e) => setMaxFollowers(e.target.value)} type="number" className="form-control" placeholder="max followers" aria-label="Server" />
                                </div>
                            </div>
                            <div style={{ minWidth: "150px" }} className="col ">
                                <div className="input-group mb-3">

                                    <input onChange={(e) => setMinFollowers(e.target.value)} type="number" className="form-control" placeholder="min followers" aria-label="Server" />
                                </div>
                            </div>
                        </div>
                        {/* tag */}
                        <div className="row">
                            <div className="col">
                                <div className="d-flex gap-2 justify-content-right py-1 flex-wrap">
                                    {
                                        tags.map((tag, index) => (
                                            <span key={index} onClick={() => setTags(tags.filter((_, i) => i !== index))} className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill  ">{tag}</span>
                                        ))}

                                    <div className="input-group mb-3">
                                        <input
                                            type="text"
                                            className="form-control dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            value={tag}
                                            onChange={(e) => handleSetTag(e.target.value)}
                                            placeholder="Categories"
                                            maxLength={254}
                                        />
                                        <ul className="dropdown-menu" >
                                            {tagsuggeslist.map((tag, index) => (
                                                <li key={index}><button className="dropdown-item" onClick={() => setTag(tag.name)}>{tag.name}</button></li>
                                            ))}
                                        </ul>
                                        <button onClick={() => { if (tag === "") { return } setTags([...tags, tag]); setTag("") }} className="btn btn-outline-secondary" type="button" id="button-addon2">Add</button>
                                        {/* <div  className="form-check form-check-inline m-2">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                                                <label className="form-check-label" for="inlineCheckbox1">contain all</label>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* country */}
                        <div className="row">
                            <div className="col">
                                <div className="d-flex gap-2 justify-content-right py-1 mb-3 flex-wrap">
                                    {countrys.map((country, index) => (
                                        <span key={index} onClick={() => setCountrys(countrys.filter((_, i) => i !== index))} className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill  ">{country}</span>
                                    ))}

                                    <select id="country" name="country" className="form-control" value={selectedCountry} onChange={handleCountryChange}>
                                        <option defaultValue={"Audience locations"}>Audience locations</option>
                                        <option value="Global">Global</option>
                                        <option value="Afghanistan">Afghanistan</option>
                                        <option value="Åland Islands">Åland Islands</option>
                                        <option value="Albania">Albania</option>
                                        <option value="Algeria">Algeria</option>
                                        <option value="American Samoa">American Samoa</option>
                                        <option value="Andorra">Andorra</option>
                                        <option value="Angola">Angola</option>
                                        <option value="Anguilla">Anguilla</option>
                                        <option value="Antarctica">Antarctica</option>
                                        <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                        <option value="Argentina">Argentina</option>
                                        <option value="Armenia">Armenia</option>
                                        <option value="Aruba">Aruba</option>
                                        <option value="Australia">Australia</option>
                                        <option value="Austria">Austria</option>
                                        <option value="Azerbaijan">Azerbaijan</option>
                                        <option value="Bahamas">Bahamas</option>
                                        <option value="Bahrain">Bahrain</option>
                                        <option value="Bangladesh">Bangladesh</option>
                                        <option value="Barbados">Barbados</option>
                                        <option value="Belarus">Belarus</option>
                                        <option value="Belgium">Belgium</option>
                                        <option value="Belize">Belize</option>
                                        <option value="Benin">Benin</option>
                                        <option value="Bermuda">Bermuda</option>
                                        <option value="Bhutan">Bhutan</option>
                                        <option value="Bolivia">Bolivia</option>
                                        <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                        <option value="Botswana">Botswana</option>
                                        <option value="Bouvet Island">Bouvet Island</option>
                                        <option value="Brazil">Brazil</option>
                                        <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                        <option value="Brunei Darussalam">Brunei Darussalam</option>
                                        <option value="Bulgaria">Bulgaria</option>
                                        <option value="Burkina Faso">Burkina Faso</option>
                                        <option value="Burundi">Burundi</option>
                                        <option value="Cambodia">Cambodia</option>
                                        <option value="Cameroon">Cameroon</option>
                                        <option value="Canada">Canada</option>
                                        <option value="Cape Verde">Cape Verde</option>
                                        <option value="Cayman Islands">Cayman Islands</option>
                                        <option value="Central African Republic">Central African Republic</option>
                                        <option value="Chad">Chad</option>
                                        <option value="Chile">Chile</option>
                                        <option value="China">China</option>
                                        <option value="Christmas Island">Christmas Island</option>
                                        <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                        <option value="Colombia">Colombia</option>
                                        <option value="Comoros">Comoros</option>
                                        <option value="Congo">Congo</option>
                                        <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                                        <option value="Cook Islands">Cook Islands</option>
                                        <option value="Costa Rica">Costa Rica</option>
                                        <option value="Cote D'ivoire">Cote D'ivoire</option>
                                        <option value="Croatia">Croatia</option>
                                        <option value="Cuba">Cuba</option>
                                        <option value="Cyprus">Cyprus</option>
                                        <option value="Czech Republic">Czech Republic</option>
                                        <option value="Denmark">Denmark</option>
                                        <option value="Djibouti">Djibouti</option>
                                        <option value="Dominica">Dominica</option>
                                        <option value="Dominican Republic">Dominican Republic</option>
                                        <option value="Ecuador">Ecuador</option>
                                        <option value="Egypt">Egypt</option>
                                        <option value="El Salvador">El Salvador</option>
                                        <option value="Equatorial Guinea">Equatorial Guinea</option>
                                        <option value="Eritrea">Eritrea</option>
                                        <option value="Estonia">Estonia</option>
                                        <option value="Ethiopia">Ethiopia</option>
                                        <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                        <option value="Faroe Islands">Faroe Islands</option>
                                        <option value="Fiji">Fiji</option>
                                        <option value="Finland">Finland</option>
                                        <option value="France">France</option>
                                        <option value="French Guiana">French Guiana</option>
                                        <option value="French Polynesia">French Polynesia</option>
                                        <option value="French Southern Territories">French Southern Territories</option>
                                        <option value="Gabon">Gabon</option>
                                        <option value="Gambia">Gambia</option>
                                        <option value="Georgia">Georgia</option>
                                        <option value="Germany">Germany</option>
                                        <option value="Ghana">Ghana</option>
                                        <option value="Gibraltar">Gibraltar</option>
                                        <option value="Greece">Greece</option>
                                        <option value="Greenland">Greenland</option>
                                        <option value="Grenada">Grenada</option>
                                        <option value="Guadeloupe">Guadeloupe</option>
                                        <option value="Guam">Guam</option>
                                        <option value="Guatemala">Guatemala</option>
                                        <option value="Guernsey">Guernsey</option>
                                        <option value="Guinea">Guinea</option>
                                        <option value="Guinea-bissau">Guinea-bissau</option>
                                        <option value="Guyana">Guyana</option>
                                        <option value="Haiti">Haiti</option>
                                        <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                                        <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                                        <option value="Honduras">Honduras</option>
                                        <option value="Hong Kong">Hong Kong</option>
                                        <option value="Hungary">Hungary</option>
                                        <option value="Iceland">Iceland</option>
                                        <option value="India">India</option>
                                        <option value="Indonesia">Indonesia</option>
                                        <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                                        <option value="Iraq">Iraq</option>
                                        <option value="Ireland">Ireland</option>
                                        <option value="Isle of Man">Isle of Man</option>
                                        <option value="Israel">Israel</option>
                                        <option value="Italy">Italy</option>
                                        <option value="Jamaica">Jamaica</option>
                                        <option value="Japan">Japan</option>
                                        <option value="Jersey">Jersey</option>
                                        <option value="Jordan">Jordan</option>
                                        <option value="Kazakhstan">Kazakhstan</option>
                                        <option value="Kenya">Kenya</option>
                                        <option value="Kiribati">Kiribati</option>
                                        <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                                        <option value="Korea, Republic of">Korea, Republic of</option>
                                        <option value="Kuwait">Kuwait</option>
                                        <option value="Kyrgyzstan">Kyrgyzstan</option>
                                        <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                        <option value="Latvia">Latvia</option>
                                        <option value="Lebanon">Lebanon</option>
                                        <option value="Lesotho">Lesotho</option>
                                        <option value="Liberia">Liberia</option>
                                        <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                                        <option value="Liechtenstein">Liechtenstein</option>
                                        <option value="Lithuania">Lithuania</option>
                                        <option value="Luxembourg">Luxembourg</option>
                                        <option value="Macao">Macao</option>
                                        <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                                        <option value="Madagascar">Madagascar</option>
                                        <option value="Malawi">Malawi</option>
                                        <option value="Malaysia">Malaysia</option>
                                        <option value="Maldives">Maldives</option>
                                        <option value="Mali">Mali</option>
                                        <option value="Malta">Malta</option>
                                        <option value="Marshall Islands">Marshall Islands</option>
                                        <option value="Martinique">Martinique</option>
                                        <option value="Mauritania">Mauritania</option>
                                        <option value="Mauritius">Mauritius</option>
                                        <option value="Mayotte">Mayotte</option>
                                        <option value="Mexico">Mexico</option>
                                        <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                        <option value="Moldova, Republic of">Moldova, Republic of</option>
                                        <option value="Monaco">Monaco</option>
                                        <option value="Mongolia">Mongolia</option>
                                        <option value="Montenegro">Montenegro</option>
                                        <option value="Montserrat">Montserrat</option>
                                        <option value="Morocco">Morocco</option>
                                        <option value="Mozambique">Mozambique</option>
                                        <option value="Myanmar">Myanmar</option>
                                        <option value="Namibia">Namibia</option>
                                        <option value="Nauru">Nauru</option>
                                        <option value="Nepal">Nepal</option>
                                        <option value="Netherlands">Netherlands</option>
                                        <option value="Netherlands Antilles">Netherlands Antilles</option>
                                        <option value="New Caledonia">New Caledonia</option>
                                        <option value="New Zealand">New Zealand</option>
                                        <option value="Nicaragua">Nicaragua</option>
                                        <option value="Niger">Niger</option>
                                        <option value="Nigeria">Nigeria</option>
                                        <option value="Niue">Niue</option>
                                        <option value="Norfolk Island">Norfolk Island</option>
                                        <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                        <option value="Norway">Norway</option>
                                        <option value="Oman">Oman</option>
                                        <option value="Pakistan">Pakistan</option>
                                        <option value="Palau">Palau</option>
                                        <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                                        <option value="Panama">Panama</option>
                                        <option value="Papua New Guinea">Papua New Guinea</option>
                                        <option value="Paraguay">Paraguay</option>
                                        <option value="Peru">Peru</option>
                                        <option value="Philippines">Philippines</option>
                                        <option value="Pitcairn">Pitcairn</option>
                                        <option value="Poland">Poland</option>
                                        <option value="Portugal">Portugal</option>
                                        <option value="Puerto Rico">Puerto Rico</option>
                                        <option value="Qatar">Qatar</option>
                                        <option value="Reunion">Reunion</option>
                                        <option value="Romania">Romania</option>
                                        <option value="Russian Federation">Russian Federation</option>
                                        <option value="Rwanda">Rwanda</option>
                                        <option value="Saint Helena">Saint Helena</option>
                                        <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                        <option value="Saint Lucia">Saint Lucia</option>
                                        <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                                        <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                                        <option value="Samoa">Samoa</option>
                                        <option value="San Marino">San Marino</option>
                                        <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                        <option value="Saudi Arabia">Saudi Arabia</option>
                                        <option value="Senegal">Senegal</option>
                                        <option value="Serbia">Serbia</option>
                                        <option value="Seychelles">Seychelles</option>
                                        <option value="Sierra Leone">Sierra Leone</option>
                                        <option value="Singapore">Singapore</option>
                                        <option value="Slovakia">Slovakia</option>
                                        <option value="Slovenia">Slovenia</option>
                                        <option value="Solomon Islands">Solomon Islands</option>
                                        <option value="Somalia">Somalia</option>
                                        <option value="South Africa">South Africa</option>
                                        <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich Islands</option>
                                        <option value="Spain">Spain</option>
                                        <option value="Sri Lanka">Sri Lanka</option>
                                        <option value="Sudan">Sudan</option>
                                        <option value="Suriname">Suriname</option>
                                        <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                                        <option value="Swaziland">Swaziland</option>
                                        <option value="Sweden">Sweden</option>
                                        <option value="Switzerland">Switzerland</option>
                                        <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                        <option value="Taiwan">Taiwan</option>
                                        <option value="Tajikistan">Tajikistan</option>
                                        <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                                        <option value="Thailand">Thailand</option>
                                        <option value="Timor-leste">Timor-leste</option>
                                        <option value="Togo">Togo</option>
                                        <option value="Tokelau">Tokelau</option>
                                        <option value="Tonga">Tonga</option>
                                        <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                        <option value="Tunisia">Tunisia</option>
                                        <option value="Turkey">Turkey</option>
                                        <option value="Turkmenistan">Turkmenistan</option>
                                        <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                        <option value="Tuvalu">Tuvalu</option>
                                        <option value="Uganda">Uganda</option>
                                        <option value="Ukraine">Ukraine</option>
                                        <option value="United Arab Emirates">United Arab Emirates</option>
                                        <option value="United Kingdom">United Kingdom</option>
                                        <option value="United States">United States</option>
                                        <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                                        <option value="Uruguay">Uruguay</option>
                                        <option value="Uzbekistan">Uzbekistan</option>
                                        <option value="Vanuatu">Vanuatu</option>
                                        <option value="Venezuela">Venezuela</option>
                                        <option value="Viet Nam">Viet Nam</option>
                                        <option value="Virgin Islands, British">Virgin Islands, British</option>
                                        <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                                        <option value="Wallis and Futuna">Wallis and Futuna</option>
                                        <option value="Western Sahara">Western Sahara</option>
                                        <option value="Yemen">Yemen</option>
                                        <option value="Zambia">Zambia</option>
                                        <option value="Zimbabwe">Zimbabwe</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {/* sort */}
                        <div className="row">
                            <div className="col">
                                <div className="d-flex gap-2 justify-content-right py-1 flex-wrap">
                                    <div className="input-group mb-3">
                                        <label className="input-group-text" htmlFor="inputGroupSelect01">Sort by</label>
                                        <select className="form-select" id="inputGroupSelect01" onChange={(e) => setSort(e.target.value)}>
                                            <option defaultValue={"Standart"} value="">standart</option>
                                            <option value="-">most followers first</option>
                                            <option value="+">least followers first</option>

                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* errors */}
                        <div style={{ marginLeft: "23px", marginTop: "10px" }} className="error">
                            {
                                <ul style={{ padding: "0" }}>
                                    {errors.map((error, index) => (
                                        <li key={index}>{` ${error}`}</li>
                                    ))}
                                </ul>
                            }
                        </div>
                        <div className="d-grid gap-2">
                            <button className="btn btn-outline-secondary" type="button" onClick={handleFilter}>Filter</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >)
    }

    function render_users() {
        return (
            <div style={{ backgroundColor: "#F8F9FA" }} className="d-flex flex-column flex-md-row p-4 gap-4 py-md-0 align-items-center justify-content-center mb-5">
                <div style={{ marginBottom: "30px" }} className="list-group d-grid gap-2 border-0 col-md-4 pt-2">
                    {kullaniciListesi.map((item, index) => (
                        <a style={{ minWidth: "300px" }} key={index} href={item.username} className="list-group-item list-group-item-action d-flex gap-3 py-2 rounded-3  " aria-current="true" >
                            <div className="container ">
                                <div className="row ">
                                    <div style={{ marginLeft: "-10px" }} className="col-2 ">
                                        <img src={item.profile_picture} alt="twbs" width="32" height="32" className=" rounded-circle flex-shrink-0" />
                                    </div>
                                    <div className="col-10 m-0 p-0">
                                        <div className="d-inline-flex align-items-center">
                                            <p className=" fw-bold mb-0 me-2">{item.username}</p>
                                            {item.followers ?
                                                <small>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-people" viewBox="0 0 16 16">
                                                        <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
                                                    </svg> : {item.followers}
                                                </small>
                                                : <></>}
                                        </div>
                                        {item.countrys ?
                                            <div>
                                                <div className="row m-0">
                                                    <small> <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className=" p-0 m-0 bi bi-globe2" viewBox="0 0 16 16">
                                                        <path d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.5-6.923c-.67.204-1.335.82-1.887 1.855q-.215.403-.395.872c.705.157 1.472.257 2.282.287zM4.249 3.539q.214-.577.481-1.078a7 7 0 0 1 .597-.933A7 7 0 0 0 3.051 3.05q.544.277 1.198.49zM3.509 7.5c.036-1.07.188-2.087.436-3.008a9 9 0 0 1-1.565-.667A6.96 6.96 0 0 0 1.018 7.5zm1.4-2.741a12.3 12.3 0 0 0-.4 2.741H7.5V5.091c-.91-.03-1.783-.145-2.591-.332M8.5 5.09V7.5h2.99a12.3 12.3 0 0 0-.399-2.741c-.808.187-1.681.301-2.591.332zM4.51 8.5c.035.987.176 1.914.399 2.741A13.6 13.6 0 0 1 7.5 10.91V8.5zm3.99 0v2.409c.91.03 1.783.145 2.591.332.223-.827.364-1.754.4-2.741zm-3.282 3.696q.18.469.395.872c.552 1.035 1.218 1.65 1.887 1.855V11.91c-.81.03-1.577.13-2.282.287zm.11 2.276a7 7 0 0 1-.598-.933 9 9 0 0 1-.481-1.079 8.4 8.4 0 0 0-1.198.49 7 7 0 0 0 2.276 1.522zm-1.383-2.964A13.4 13.4 0 0 1 3.508 8.5h-2.49a6.96 6.96 0 0 0 1.362 3.675c.47-.258.995-.482 1.565-.667m6.728 2.964a7 7 0 0 0 2.275-1.521 8.4 8.4 0 0 0-1.197-.49 9 9 0 0 1-.481 1.078 7 7 0 0 1-.597.933M8.5 11.909v3.014c.67-.204 1.335-.82 1.887-1.855q.216-.403.395-.872A12.6 12.6 0 0 0 8.5 11.91zm3.555-.401c.57.185 1.095.409 1.565.667A6.96 6.96 0 0 0 14.982 8.5h-2.49a13.4 13.4 0 0 1-.437 3.008M14.982 7.5a6.96 6.96 0 0 0-1.362-3.675c-.47.258-.995.482-1.565.667.248.92.4 1.938.437 3.008zM11.27 2.461q.266.502.482 1.078a8.4 8.4 0 0 0 1.196-.49 7 7 0 0 0-2.275-1.52c.218.283.418.597.597.932m-.488 1.343a8 8 0 0 0-.395-.872C9.835 1.897 9.17 1.282 8.5 1.077V4.09c.81-.03 1.577-.13 2.282-.287z" />
                                                    </svg> :

                                                        {item.countrys.map((country, countryIndex) => (
                                                            <small className="countrys" key={countryIndex}>{country.name}</small>
                                                        ))}

                                                    </small>
                                                </div>
                                                <div className="row m-0">
                                                    <small>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-tags" viewBox="0 0 16 16">
                                                            <path d="M3 2v4.586l7 7L14.586 9l-7-7zM2 2a1 1 0 0 1 1-1h4.586a1 1 0 0 1 .707.293l7 7a1 1 0 0 1 0 1.414l-4.586 4.586a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 2 6.586z" />
                                                            <path d="M5.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1m0 1a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M1 7.086a1 1 0 0 0 .293.707L8.75 15.25l-.043.043a1 1 0 0 1-1.414 0l-7-7A1 1 0 0 1 0 7.586V3a1 1 0 0 1 1-1z" />
                                                        </svg> :

                                                        {item.tags.map((country, countryIndex) => (
                                                            <small className="tags" key={countryIndex}>{country.name}</small>
                                                        ))}

                                                    </small>
                                                </div>
                                            </div>
                                            : <></>}
                                    </div>
                                </div>
                            </div>
                        </a>
                    ))}
                    {isover ? <></> : <div className="d-flex gap-2 justify-content-center pb-5">
                        <svg onClick={handleloadmore} xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" className="bi bi-arrow-down-circle" viewBox="0 0 16 16">
                            <path fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v5.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293z" />
                        </svg>
                    </div>}
                </div>
            </div>
        );
    }

    function filter_by_user_profile() {
        return (<div href="#" className=" list-group-item justify-content-center  d-flex gap-3 py-3 rounded-3" aria-current="true">
            <div className="d-flex gap-4 w-100 justify-content-center">
                <div>
                    <div className="container text-center pt-2  ">
                        {/* tag */}
                        <div className="row">
                            <div className="col">
                                <div className="d-flex gap-2 justify-content-right py-1 flex-wrap">
                                    {
                                        tags_p.map((tag, index) => (
                                            <span key={index} onClick={() => setTags_p(tags_p.filter((_, i) => i !== index))} className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill  ">{tag}</span>
                                        ))}

                                    <div className="input-group mb-3">
                                        <input
                                            type="text"
                                            className="form-control dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            value={tag_p}
                                            onChange={(e) => handleSetTag_p(e.target.value)}
                                            placeholder="Categories"
                                            maxLength={254}
                                        />
                                        <ul className="dropdown-menu" >
                                            {tagsuggeslist.map((tag_p, index) => (
                                                <li key={index}><button className="dropdown-item" onClick={() => setTag_p(tag_p.name)}>{tag_p.name}</button></li>
                                            ))}
                                        </ul>
                                        <button onClick={() => { if (tag_p === "") { return } setTags_p([...tags_p, tag_p]); setTag_p("") }} className="btn btn-outline-secondary" type="button" id="button-addon2">Add</button>
                                        {/* <div  className="form-check form-check-inline m-2">
                                            <input className="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1"/>
                                                <label className="form-check-label" for="inlineCheckbox1">contain all</label>
                                        </div> */}

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* country */}
                        <div className="row">
                            <div className="col">
                                <div className="d-flex gap-2 justify-content-right py-1 mb-3 flex-wrap">
                                    {countrys_p.map((country, index) => (
                                        <span key={index} onClick={() => setCountrys_p(countrys_p.filter((_, i) => i !== index))} className="badge bg-success-subtle border border-success-subtle text-success-emphasis rounded-pill  ">{country}</span>
                                    ))}

                                    <select id="country" name="country" className="form-control" value={selectedCountry} onChange={handleCountryChange_p}>
                                        <option defaultValue={"Audience locations"}>Audience locations</option>
                                        <option value="Global">Global</option>
                                        <option value="Afghanistan">Afghanistan</option>
                                        <option value="Åland Islands">Åland Islands</option>
                                        <option value="Albania">Albania</option>
                                        <option value="Algeria">Algeria</option>
                                        <option value="American Samoa">American Samoa</option>
                                        <option value="Andorra">Andorra</option>
                                        <option value="Angola">Angola</option>
                                        <option value="Anguilla">Anguilla</option>
                                        <option value="Antarctica">Antarctica</option>
                                        <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                                        <option value="Argentina">Argentina</option>
                                        <option value="Armenia">Armenia</option>
                                        <option value="Aruba">Aruba</option>
                                        <option value="Australia">Australia</option>
                                        <option value="Austria">Austria</option>
                                        <option value="Azerbaijan">Azerbaijan</option>
                                        <option value="Bahamas">Bahamas</option>
                                        <option value="Bahrain">Bahrain</option>
                                        <option value="Bangladesh">Bangladesh</option>
                                        <option value="Barbados">Barbados</option>
                                        <option value="Belarus">Belarus</option>
                                        <option value="Belgium">Belgium</option>
                                        <option value="Belize">Belize</option>
                                        <option value="Benin">Benin</option>
                                        <option value="Bermuda">Bermuda</option>
                                        <option value="Bhutan">Bhutan</option>
                                        <option value="Bolivia">Bolivia</option>
                                        <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
                                        <option value="Botswana">Botswana</option>
                                        <option value="Bouvet Island">Bouvet Island</option>
                                        <option value="Brazil">Brazil</option>
                                        <option value="British Indian Ocean Territory">British Indian Ocean Territory</option>
                                        <option value="Brunei Darussalam">Brunei Darussalam</option>
                                        <option value="Bulgaria">Bulgaria</option>
                                        <option value="Burkina Faso">Burkina Faso</option>
                                        <option value="Burundi">Burundi</option>
                                        <option value="Cambodia">Cambodia</option>
                                        <option value="Cameroon">Cameroon</option>
                                        <option value="Canada">Canada</option>
                                        <option value="Cape Verde">Cape Verde</option>
                                        <option value="Cayman Islands">Cayman Islands</option>
                                        <option value="Central African Republic">Central African Republic</option>
                                        <option value="Chad">Chad</option>
                                        <option value="Chile">Chile</option>
                                        <option value="China">China</option>
                                        <option value="Christmas Island">Christmas Island</option>
                                        <option value="Cocos (Keeling) Islands">Cocos (Keeling) Islands</option>
                                        <option value="Colombia">Colombia</option>
                                        <option value="Comoros">Comoros</option>
                                        <option value="Congo">Congo</option>
                                        <option value="Congo, The Democratic Republic of The">Congo, The Democratic Republic of The</option>
                                        <option value="Cook Islands">Cook Islands</option>
                                        <option value="Costa Rica">Costa Rica</option>
                                        <option value="Cote D'ivoire">Cote D'ivoire</option>
                                        <option value="Croatia">Croatia</option>
                                        <option value="Cuba">Cuba</option>
                                        <option value="Cyprus">Cyprus</option>
                                        <option value="Czech Republic">Czech Republic</option>
                                        <option value="Denmark">Denmark</option>
                                        <option value="Djibouti">Djibouti</option>
                                        <option value="Dominica">Dominica</option>
                                        <option value="Dominican Republic">Dominican Republic</option>
                                        <option value="Ecuador">Ecuador</option>
                                        <option value="Egypt">Egypt</option>
                                        <option value="El Salvador">El Salvador</option>
                                        <option value="Equatorial Guinea">Equatorial Guinea</option>
                                        <option value="Eritrea">Eritrea</option>
                                        <option value="Estonia">Estonia</option>
                                        <option value="Ethiopia">Ethiopia</option>
                                        <option value="Falkland Islands (Malvinas)">Falkland Islands (Malvinas)</option>
                                        <option value="Faroe Islands">Faroe Islands</option>
                                        <option value="Fiji">Fiji</option>
                                        <option value="Finland">Finland</option>
                                        <option value="France">France</option>
                                        <option value="French Guiana">French Guiana</option>
                                        <option value="French Polynesia">French Polynesia</option>
                                        <option value="French Southern Territories">French Southern Territories</option>
                                        <option value="Gabon">Gabon</option>
                                        <option value="Gambia">Gambia</option>
                                        <option value="Georgia">Georgia</option>
                                        <option value="Germany">Germany</option>
                                        <option value="Ghana">Ghana</option>
                                        <option value="Gibraltar">Gibraltar</option>
                                        <option value="Greece">Greece</option>
                                        <option value="Greenland">Greenland</option>
                                        <option value="Grenada">Grenada</option>
                                        <option value="Guadeloupe">Guadeloupe</option>
                                        <option value="Guam">Guam</option>
                                        <option value="Guatemala">Guatemala</option>
                                        <option value="Guernsey">Guernsey</option>
                                        <option value="Guinea">Guinea</option>
                                        <option value="Guinea-bissau">Guinea-bissau</option>
                                        <option value="Guyana">Guyana</option>
                                        <option value="Haiti">Haiti</option>
                                        <option value="Heard Island and Mcdonald Islands">Heard Island and Mcdonald Islands</option>
                                        <option value="Holy See (Vatican City State)">Holy See (Vatican City State)</option>
                                        <option value="Honduras">Honduras</option>
                                        <option value="Hong Kong">Hong Kong</option>
                                        <option value="Hungary">Hungary</option>
                                        <option value="Iceland">Iceland</option>
                                        <option value="India">India</option>
                                        <option value="Indonesia">Indonesia</option>
                                        <option value="Iran, Islamic Republic of">Iran, Islamic Republic of</option>
                                        <option value="Iraq">Iraq</option>
                                        <option value="Ireland">Ireland</option>
                                        <option value="Isle of Man">Isle of Man</option>
                                        <option value="Israel">Israel</option>
                                        <option value="Italy">Italy</option>
                                        <option value="Jamaica">Jamaica</option>
                                        <option value="Japan">Japan</option>
                                        <option value="Jersey">Jersey</option>
                                        <option value="Jordan">Jordan</option>
                                        <option value="Kazakhstan">Kazakhstan</option>
                                        <option value="Kenya">Kenya</option>
                                        <option value="Kiribati">Kiribati</option>
                                        <option value="Korea, Democratic People's Republic of">Korea, Democratic People's Republic of</option>
                                        <option value="Korea, Republic of">Korea, Republic of</option>
                                        <option value="Kuwait">Kuwait</option>
                                        <option value="Kyrgyzstan">Kyrgyzstan</option>
                                        <option value="Lao People's Democratic Republic">Lao People's Democratic Republic</option>
                                        <option value="Latvia">Latvia</option>
                                        <option value="Lebanon">Lebanon</option>
                                        <option value="Lesotho">Lesotho</option>
                                        <option value="Liberia">Liberia</option>
                                        <option value="Libyan Arab Jamahiriya">Libyan Arab Jamahiriya</option>
                                        <option value="Liechtenstein">Liechtenstein</option>
                                        <option value="Lithuania">Lithuania</option>
                                        <option value="Luxembourg">Luxembourg</option>
                                        <option value="Macao">Macao</option>
                                        <option value="Macedonia, The Former Yugoslav Republic of">Macedonia, The Former Yugoslav Republic of</option>
                                        <option value="Madagascar">Madagascar</option>
                                        <option value="Malawi">Malawi</option>
                                        <option value="Malaysia">Malaysia</option>
                                        <option value="Maldives">Maldives</option>
                                        <option value="Mali">Mali</option>
                                        <option value="Malta">Malta</option>
                                        <option value="Marshall Islands">Marshall Islands</option>
                                        <option value="Martinique">Martinique</option>
                                        <option value="Mauritania">Mauritania</option>
                                        <option value="Mauritius">Mauritius</option>
                                        <option value="Mayotte">Mayotte</option>
                                        <option value="Mexico">Mexico</option>
                                        <option value="Micronesia, Federated States of">Micronesia, Federated States of</option>
                                        <option value="Moldova, Republic of">Moldova, Republic of</option>
                                        <option value="Monaco">Monaco</option>
                                        <option value="Mongolia">Mongolia</option>
                                        <option value="Montenegro">Montenegro</option>
                                        <option value="Montserrat">Montserrat</option>
                                        <option value="Morocco">Morocco</option>
                                        <option value="Mozambique">Mozambique</option>
                                        <option value="Myanmar">Myanmar</option>
                                        <option value="Namibia">Namibia</option>
                                        <option value="Nauru">Nauru</option>
                                        <option value="Nepal">Nepal</option>
                                        <option value="Netherlands">Netherlands</option>
                                        <option value="Netherlands Antilles">Netherlands Antilles</option>
                                        <option value="New Caledonia">New Caledonia</option>
                                        <option value="New Zealand">New Zealand</option>
                                        <option value="Nicaragua">Nicaragua</option>
                                        <option value="Niger">Niger</option>
                                        <option value="Nigeria">Nigeria</option>
                                        <option value="Niue">Niue</option>
                                        <option value="Norfolk Island">Norfolk Island</option>
                                        <option value="Northern Mariana Islands">Northern Mariana Islands</option>
                                        <option value="Norway">Norway</option>
                                        <option value="Oman">Oman</option>
                                        <option value="Pakistan">Pakistan</option>
                                        <option value="Palau">Palau</option>
                                        <option value="Palestinian Territory, Occupied">Palestinian Territory, Occupied</option>
                                        <option value="Panama">Panama</option>
                                        <option value="Papua New Guinea">Papua New Guinea</option>
                                        <option value="Paraguay">Paraguay</option>
                                        <option value="Peru">Peru</option>
                                        <option value="Philippines">Philippines</option>
                                        <option value="Pitcairn">Pitcairn</option>
                                        <option value="Poland">Poland</option>
                                        <option value="Portugal">Portugal</option>
                                        <option value="Puerto Rico">Puerto Rico</option>
                                        <option value="Qatar">Qatar</option>
                                        <option value="Reunion">Reunion</option>
                                        <option value="Romania">Romania</option>
                                        <option value="Russian Federation">Russian Federation</option>
                                        <option value="Rwanda">Rwanda</option>
                                        <option value="Saint Helena">Saint Helena</option>
                                        <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
                                        <option value="Saint Lucia">Saint Lucia</option>
                                        <option value="Saint Pierre and Miquelon">Saint Pierre and Miquelon</option>
                                        <option value="Saint Vincent and The Grenadines">Saint Vincent and The Grenadines</option>
                                        <option value="Samoa">Samoa</option>
                                        <option value="San Marino">San Marino</option>
                                        <option value="Sao Tome and Principe">Sao Tome and Principe</option>
                                        <option value="Saudi Arabia">Saudi Arabia</option>
                                        <option value="Senegal">Senegal</option>
                                        <option value="Serbia">Serbia</option>
                                        <option value="Seychelles">Seychelles</option>
                                        <option value="Sierra Leone">Sierra Leone</option>
                                        <option value="Singapore">Singapore</option>
                                        <option value="Slovakia">Slovakia</option>
                                        <option value="Slovenia">Slovenia</option>
                                        <option value="Solomon Islands">Solomon Islands</option>
                                        <option value="Somalia">Somalia</option>
                                        <option value="South Africa">South Africa</option>
                                        <option value="South Georgia and The South Sandwich Islands">South Georgia and The South Sandwich Islands</option>
                                        <option value="Spain">Spain</option>
                                        <option value="Sri Lanka">Sri Lanka</option>
                                        <option value="Sudan">Sudan</option>
                                        <option value="Suriname">Suriname</option>
                                        <option value="Svalbard and Jan Mayen">Svalbard and Jan Mayen</option>
                                        <option value="Swaziland">Swaziland</option>
                                        <option value="Sweden">Sweden</option>
                                        <option value="Switzerland">Switzerland</option>
                                        <option value="Syrian Arab Republic">Syrian Arab Republic</option>
                                        <option value="Taiwan">Taiwan</option>
                                        <option value="Tajikistan">Tajikistan</option>
                                        <option value="Tanzania, United Republic of">Tanzania, United Republic of</option>
                                        <option value="Thailand">Thailand</option>
                                        <option value="Timor-leste">Timor-leste</option>
                                        <option value="Togo">Togo</option>
                                        <option value="Tokelau">Tokelau</option>
                                        <option value="Tonga">Tonga</option>
                                        <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                                        <option value="Tunisia">Tunisia</option>
                                        <option value="Turkey">Turkey</option>
                                        <option value="Turkmenistan">Turkmenistan</option>
                                        <option value="Turks and Caicos Islands">Turks and Caicos Islands</option>
                                        <option value="Tuvalu">Tuvalu</option>
                                        <option value="Uganda">Uganda</option>
                                        <option value="Ukraine">Ukraine</option>
                                        <option value="United Arab Emirates">United Arab Emirates</option>
                                        <option value="United Kingdom">United Kingdom</option>
                                        <option value="United States">United States</option>
                                        <option value="United States Minor Outlying Islands">United States Minor Outlying Islands</option>
                                        <option value="Uruguay">Uruguay</option>
                                        <option value="Uzbekistan">Uzbekistan</option>
                                        <option value="Vanuatu">Vanuatu</option>
                                        <option value="Venezuela">Venezuela</option>
                                        <option value="Viet Nam">Viet Nam</option>
                                        <option value="Virgin Islands, British">Virgin Islands, British</option>
                                        <option value="Virgin Islands, U.S.">Virgin Islands, U.S.</option>
                                        <option value="Wallis and Futuna">Wallis and Futuna</option>
                                        <option value="Western Sahara">Western Sahara</option>
                                        <option value="Yemen">Yemen</option>
                                        <option value="Zambia">Zambia</option>
                                        <option value="Zimbabwe">Zimbabwe</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        {/* check box */}
                        <div style={{ padding: "15px" }} className="d-flex gap-2 justify-content-right py-1 flex-wrap ">
                            <div className="form-check form-switch">
                                <input
                                    checked={checked}
                                    onChange={handleCheckboxChange}
                                    style={{ fontSize: "20px" }}
                                    className="form-check-input custom-checkbox"
                                    type="checkbox"
                                    role="switch"
                                    id="flexSwitchCheckDefault"
                                />

                                <label style={{ marginLeft: "15px", marginTop: "3px", marginRight: "5px" }} className="form-check-label" htmlFor="flexSwitchCheckDefault">Content creator</label>
                                ( <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="20"
                                    fill="#49AFFE"
                                    viewBox="0 0 16 16"
                                // style={{
                                //     position: "absolute",
                                //     bottom: "0px",
                                //     right: "0px",
                                //     transform: "translate(30%, 30%)", // biraz üstüne gelsin diye
                                //     backgroundColor: "white",

                                //     padding: "2px"
                                // }}
                                >
                                    <path d="M10 9.05a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
                                    <path d="M2 1a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zM1 3a1 1 0 0 1 1-1h2v2H1zm4 10V2h9a1 1 0 0 1 1 1v9c0 .285-.12.543-.31.725C14.15 11.494 12.822 10 10 10c-3.037 0-4.345 1.73-4.798 3zm-4-2h3v2H2a1 1 0 0 1-1-1zm3-1H1V8h3zm0-3H1V5h3z" />
                                </svg> )
                            </div>

                        </div>
                        {/* errors */}
                        <div style={{ marginLeft: "23px", marginTop: "10px" }} className="error">
                            {
                                <ul style={{ padding: "0" }}>
                                    {errors.map((error, index) => (
                                        <li key={index}>{` ${error}`}</li>
                                    ))}
                                </ul>
                            }
                        </div>
                        <div className="d-grid gap-2">
                            <button className="btn btn-outline-secondary" type="button" onClick={handleFilter_p}>Filter</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >)
    }

    useEffect(() => {
        setKullaniciListesi([]);
        setRange(10);
        setIsOver(true);
        setErrors([]);
    }, [selectedsearchtype])

    useEffect(() => {
        setRange(10);
    }, [countrys, tags, maxFollowers, minFollowers, sort, socialMedia, countrys_p, tags_p, checked, name])

    return (
        <div>
            <div className="container  ">
                <div className="d-flex flex-column flex-md-row p-4 gap-4  align-items-center justify-content-center mt-1">
                    <div className="list-group d-grid gap-2 border-0 col-md-6  ">

                        <svg onClick={handleShow} xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-exclamation-circle warning" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4m.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2" />
                        </svg>
                        {
                            show && (

                                <div className="modal fade show overlay " tabIndex="-1" role="dialog" >
                                    <div className="modal-dialog">
                                        <div style={{ backgroundColor: "#F8D7DA", borderRadius: "10px" }} className="modal-content">

                                            <div className="modal-body">
                                                Before contacting anyone, especially a famous person, we recommend that you examine their profile,
                                                click on their social media links and check if they are real accounts.
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary" onClick={handleClose} data-bs-dismiss="modal">Close</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>)}


                        <div className="col-lg-6 col-xxl-4 my-5 mx-auto phonea">
                            <div className="d-grid gap-2">

                                <button
                                    onClick={() => { setSelectedsearchtype(0) }}
                                    className={selectedsearchtype === 0 ? "navbtnsa btn btn-outline-secondary" : "navbtna btn btn-outline-secondary"}
                                    type="button">
                                    Search by username
                                </button>

                                <button
                                    onClick={() => { setSelectedsearchtype(1) }}
                                    className={selectedsearchtype === 1 ? "navbtnsa btn btn-outline-secondary" : "navbtna btn btn-outline-secondary"}
                                    type="button">
                                    Filter by social media
                                </button>

                                <button
                                    onClick={() => { setSelectedsearchtype(2) }}
                                    className={selectedsearchtype === 2 ? "navbtnsa btn btn-outline-secondary" : "navbtna btn btn-outline-secondary"}
                                    type="button">
                                    Filter by user profile
                                </button>

                            </div>
                        </div>
                        <div className="pca">
                            <div className=" d-flex gap-2 justify-content-center py-5 mt-1">

                                <button
                                    onClick={() => { setSelectedsearchtype(0) }}
                                    className={selectedsearchtype === 0 ? "navbtnsa btn btn-outline-secondary" : "navbtna btn btn-outline-secondary"}
                                    type="button">
                                    Search by username
                                </button>

                                <button
                                    onClick={() => { setSelectedsearchtype(1) }}
                                    className={selectedsearchtype === 1 ? "navbtnsa btn btn-outline-secondary" : "navbtna btn btn-outline-secondary"}
                                    type="button">
                                    Filter by social media
                                </button>

                                <button
                                    onClick={() => { setSelectedsearchtype(2) }}
                                    className={selectedsearchtype === 2 ? "navbtnsa btn btn-outline-secondary" : "navbtna btn btn-outline-secondary"}
                                    type="button">
                                    Filter by user profile
                                </button>
                            </div>
                        </div>
                        {selectedsearchtype === 0 && search_user()}
                        {selectedsearchtype === 1 && filter_by_social_media()}
                        {selectedsearchtype === 2 && filter_by_user_profile()}
                    </div>
                </div>
            </div>
            {render_users()}
        </div >
    );

} export default Search;

